import { BaseModel } from './base-model';

import { size, filter } from 'lodash';

/**
 * WiP model for location
 */
export class LocationModel extends BaseModel {
  _id: string;
  id: string;

  name: string;
  ean?: string;
  wh: string;
  fullname?: string;
  email: string;

  addresses: any[];

  sendcloudSenderAddressId: number;
  website: string;
  bankAccountNumber: string;

  constructor(originalValue?: Partial<LocationModel>) {
    super(originalValue);
  }
}
